import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { Appointment } from '@/models/appointment/Appointment.ts';
import { AppointmentCollection } from '@/models/appointment/book-appointment-collection-dto.ts';

import { AppointmentCollectionResponse, getAppointmentCollection } from '@/services/appointmentService.ts';

interface UseCollectionAppointmentsParams {
    collectionId: string;
    instanceId: string;
    customerId: string;
    enabled?: boolean;
}

interface UseCollectionAppointmentsResult {
    appointments: Appointment[] | undefined;
    collection: AppointmentCollection | undefined;
    isLoading: boolean;
    error?: Error | undefined;
}

export const useCollectionAppointments = ({
    collectionId,
    instanceId,
    customerId,
    enabled,
}: UseCollectionAppointmentsParams): UseCollectionAppointmentsResult => {
    const shouldFetch = Boolean(collectionId && instanceId && customerId && enabled);

    const { data, error, isLoading } = useSWRImmutable<AppointmentCollectionResponse, AxiosError>(
        shouldFetch ? ['collection_appointments', collectionId, instanceId, customerId] : undefined,
        () => getAppointmentCollection(collectionId, instanceId, customerId)
    );

    const collection = data?.data?.collection;
    const appointments = data?.data?.appointments;

    return {
        appointments,
        collection,
        isLoading,
        error,
    };
};
